module.exports = __webpack_public_path__ + "h5/img/logo.3956cdd9.png";